<template>
   <section v-if="props.url">
      <iframe
         class="w-full"
         :style="`min-height: ${props.minHeight || 600}px`"
         :title="props.title || 'iFrame'"
         :src="props.url"
      ></iframe>
   </section>
</template>

<script setup lang="ts">
interface Props {
   url: string;
   title?: string;
   minHeight?: number | string;
   margin?: string;
}
const props = defineProps<Props>();
</script>
